<div class="card" *ngIf="submittedConsultant">
  <div class="ph-row p-md-2">
    <span class="text-double-dot" i18n>Your Upline Organizer is</span>
    <strong data-private>{{ submittedConsultant.organizerInfo.fullName }}</strong>
  </div>
  <div class="ph-row px-md-2 pb-md-2">
    <span class="text-double-dot" i18n>Organizer's Phone</span>
    <strong data-private>{{ submittedConsultant.organizerInfo.phoneNumber | phoneFormat }}</strong>
  </div>
</div>
